<template>
  <NoticeBase
    :notice="notice"
    :relative-time="relativeTime"
    notice-class="inbox-error-notice"
    @open="open"
    @archived="$emit('archived', $event)"
  >
    <span class="error-icon" aria-hidden="true">
      <WarningIcon />
    </span>
    <span class="text">{{ message }}</span>
    <span v-if="title" class="title">{{ title }}</span>
  </NoticeBase>
</template>

<script lang="ts">
import { defineComponent, PropType, toRef } from "vue";

import type { FullNotice } from "@ctrl/controller-rpc";

import WarningIcon from "@/components/icons/WarningIcon.vue";
import { openNotice, useNoticeRelativeTime } from "@/components/inbox/notice";
import NoticeBase from "@/components/inbox/NoticeBase.vue";
import * as inject from "@/components/inject";

export default defineComponent({
  name: "InboxErrorNotice",
  components: { NoticeBase, WarningIcon },
  props: {
    notice: {
      type: Object as PropType<FullNotice>,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: false,
    },
  },
  emits: {
    archived: (_noticeId: string) => true,
  },
  setup(props) {
    const controller = inject.controller();
    const logger = inject.logger();
    const router = inject.router();
    const relativeTime = useNoticeRelativeTime(toRef(props, "notice"));

    const open = async () => {
      await openNotice(controller, router, logger, props.notice);
    };

    return { open, relativeTime };
  },
});
</script>

<style scoped lang="scss">
.error-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  flex: 0 0 20px;
}

.error-icon :deep(svg) {
  width: 18px;
  height: 18px;
}

.text {
  margin-inline-start: 6px;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  @include themed() {
    color: t($grey-90);
  }
}
</style>
